<div class="bg-[#111c43] h-screen w-full">
    <router-outlet></router-outlet>
</div>

